import { ReduxState } from '../../redux/reducers';
import { useShallowEqualSelector } from '../redux';

export const useIsRequirePayment = () => {
  const merchantResourceBooksState = useShallowEqualSelector(
    (state: ReduxState) => state.merchantsResourcesBooks,
  );
  const { settings, merchantResource } = merchantResourceBooksState;

  // unspecifiedという状態が謎なので、API側含めて適切にモデリングするのがベストだとは思う..
  const paymentMethods =
    settings?.payment?.paymentMethods.filter(
      (paymentMethod) => paymentMethod.method !== 'unspecified',
    ) ?? [];
  const isRequireBookingPagePayment = merchantResource?.paymentStep
    ? merchantResource.paymentStep
    : false;
  return paymentMethods.length > 0 && isRequireBookingPagePayment;
};
